import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';
const {Text, Paragraph} = Typography;
const Content = Layout;

const TresPD = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Intellectual Property</Paragraph>
        <Text className='BaseText2'>In 2020, the European Patent Office showed that the pharmaceutical/health care products in the industry are considered one of the highest sectors in which biotechnological patents are given with 55% overall. In our condition, one element of the biosensor system can be registered. <b>We have examined the conditions and legislations which have to be considered iMoAge to comply with the applicability requirements in which we have to guarantee the novelty, inventive step and industrial applicability [10].</b></Text>
        <Text className='BaseText' style={{marginTop: '3%', textAlign: 'center'}}><i>In the following PDF you can find the entire information of our intellectual property study </i></Text>
        <Content style={{width: '100%', marginTop: '1%', background: 'transparent', textAlign: 'right'}}>
          <a style={{width: 'fit-content', marginLeft: 'auto', marginRight: '50px', marginBottom: '5px'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/emprendimiento/intelectual-property.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
          <p style={{textAlign: 'right'}}><i>Download Here</i></p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default TresPD;
